'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'cannon';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e642';
var svgPathData = ['M106.1 378.9c-23.7-47.3-4.6-104.9 42.7-128.7 22.2-10.7 90.8-36.6 170.7-65.6 78.8-28.6 164.8-58.9 218.5-77.7 7.3-2.6 15.6 .6 19.2 8l30.7 61.4c3.7 7.3 1.3 15.8-5.2 20.2-24.3 16.3-56.1 37.5-90.8 60.6-24.9-20.7-57-33.2-92-33.2-79.5 0-144 64.5-144 144 0 13.4 1.8 26.4 5.2 38.7-11.5 6.9-20.5 12.2-26.6 15.3-47.4 23.5-104.9 4.3-128.5-43z', 'M261.2 406.7c-11.5 6.9-20.5 12.2-26.6 15.3-47.4 23.5-104.9 4.3-128.5-43s-4.6-104.9 42.7-128.7c22.2-10.7 90.8-36.6 170.7-65.6 78.8-28.6 164.8-58.9 218.5-77.7 7.3-2.6 15.6 .6 19.2 8l30.7 61.4c3.7 7.3 1.3 15.8-5.2 20.2-24.3 16.3-56.1 37.5-90.8 60.6 12.4 10.3 23.1 22.8 31.5 36.7 32.9-21.9 62.9-41.9 86-57.4 26.7-17.9 35.7-52.7 21.4-81.5L600.2 93.5c-14.4-28.7-47.7-42.4-78-31.8-107.4 37.6-345.1 121.5-394.6 145.5-56.1 28-85.9 87.7-78.5 146.6L26.5 365.1C2.8 376.9-6.8 405.8 5.1 429.5s40.7 33.3 64.4 21.5L92 439.7c42.7 41.2 108.3 53.2 164.4 25.1 6.1-3.2 14.8-8.1 25.4-14.5-9.2-13.1-16.2-27.8-20.6-43.6zM400 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 176a112 112 0 1 0 0-224 112 112 0 1 0 0 224z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCannon = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;